var AveEvent;
(function (AveEvent) {
    // Session
    AveEvent["AVEStartSession"] = "AVEStartSession";
    AveEvent["AVEEndSession"] = "AVEEndSession";
    // Media
    AveEvent["AVEShowMediaItem"] = "AVEShowMediaItem";
    AveEvent["AVEPauseMediaItem"] = "AVEPauseMediaItem";
    AveEvent["AVEResumeMediaItem"] = "AVEResumeMediaItem";
    AveEvent["AVEStopMediaItem"] = "AVEStopMediaItem";
    AveEvent["AVEChangeVolume"] = "AVEChangeVolume";
    AveEvent["AVEStartComparisonMode"] = "AVEStartComparisonMode";
    AveEvent["AVESetComparisonSeparator"] = "AVESetComparisonSeparator";
    AveEvent["AVEStopComparisonMode"] = "AVEStopComparisonMode";
    // Car
    AveEvent["AVELoadCar"] = "AVELoadCar";
    AveEvent["AVEChangeCar"] = "AVEChangeCar";
    AveEvent["AVESelectCar"] = "AVESelectCar";
    AveEvent["AVESetCarVisibility"] = "AVESetCarVisibility";
    AveEvent["AVEIsolateCarParts"] = "AVEIsolateCarParts";
    AveEvent["AVEHideCarParts"] = "AVEHideCarParts";
    AveEvent["AVESetSteeringAngle"] = "AVESetSteeringAngle";
    AveEvent["AVEGetAnimationSpots"] = "AVEGetAnimationSpots";
    AveEvent["AVEReceiveAnimationSpotsUpdate"] = "AVEReceiveAnimationSpotsUpdate";
    AveEvent["AVESetAnimationSpotsVisibility"] = "AVESetAnimationSpotsVisibility";
    AveEvent["AVEGetInteractionSpots"] = "AVEGetInteractionSpots";
    AveEvent["AVEReceiveInteractionSpotsUpdate"] = "AVEReceiveInteractionSpotsUpdate";
    AveEvent["AVESetCarTransform"] = "AVESetCarTransform";
    AveEvent["AVEListModelConfigurations"] = "AVEListModelConfigurations";
    AveEvent["AVEDisplayConsumptionData"] = "AVEDisplayConsumptionData";
    // Environment
    AveEvent["AVEListEnvironments"] = "AVEListEnvironments";
    AveEvent["AVESelectEnvironment"] = "AVESelectEnvironment";
    // Animation
    AveEvent["AVEListAnimations"] = "AVEListAnimations";
    AveEvent["AVETriggerAnimations"] = "AVETriggerAnimations";
    AveEvent["AVEEndAnimations"] = "AVEEndAnimations";
    // Camera
    AveEvent["AVESetCameraMode"] = "AVESetCameraMode";
    AveEvent["AVEListCameras"] = "AVEListCameras";
    AveEvent["AVESelectCamera"] = "AVESelectCamera";
    AveEvent["AVEResetCamera"] = "AVEResetCamera";
    AveEvent["AVEGetCurrentCameraDefinition"] = "AVEGetCurrentCameraDefinition";
    AveEvent["AVESetCameraDefinition"] = "AVESetCameraDefinition";
    // Camera Orbit
    AveEvent["AVEListCameraOrbits"] = "AVEListCameraOrbits";
    AveEvent["AVEModifyCameraOrbit"] = "AVEModifyCameraOrbit";
    AveEvent["AVEStartOrResumeCameraOrbit"] = "AVEStartOrResumeCameraOrbit";
    AveEvent["AVEStopCameraOrbit"] = "AVEStopCameraOrbit";
    // Cargo Loads
    AveEvent["AVEHideAllCargoLoads"] = "AVEHideAllCargoLoads";
    AveEvent["AVEListCargoLoads"] = "AVEListCargoLoads";
    AveEvent["AVEShowCargoLoads"] = "AVEShowCargoLoads";
    // Driving Scene
    AveEvent["AVEListDrivingScenes"] = "AVEListDrivingScenes";
    AveEvent["AVEDrivingSceneStart"] = "AVEDrivingSceneStart";
    AveEvent["AVEDrivingSceneStop"] = "AVEDrivingSceneStop";
    // VR
    AveEvent["AVEListVRSpots"] = "AVEListVRSpots";
    AveEvent["AVESelectVRSpot"] = "AVESelectVRSpot";
    AveEvent["AVEHideHSWOverlay"] = "AVEHideHSWOverlay";
    AveEvent["AVEVRControl"] = "AVEVRControl";
    AveEvent["AVEVRCalibration"] = "AVEVRCalibration";
    // Rendering
    AveEvent["AVERenderImage"] = "AVERenderImage";
    AveEvent["AVERenderAnimation"] = "AVERenderAnimation";
    AveEvent["AVERenderCameraFlight"] = "AVERenderCameraFlight";
    AveEvent["AVEGetImage"] = "AVEGetImage";
    AveEvent["AVEDeleteImage"] = "AVEDeleteImage";
    AveEvent["AVERenderImageJob"] = "AVERenderImageJob";
    AveEvent["AVERenderAnimationJob"] = "AVERenderAnimationJob";
    AveEvent["AVERenderCameraFlightJob"] = "AVERenderCameraFlightJob";
    // Utils
    AveEvent["AVEGetSystemInfo"] = "AVEGetSystemInfo";
    AveEvent["AVEGetStates"] = "AVEGetStates";
    // Deprecated
    AveEvent["AVEShowRenderer"] = "AVEShowRenderer";
    AveEvent["AVEStartPlaylist"] = "AVEStartPlaylist";
    AveEvent["AVEInteractionSpots"] = "AVEInteractionSpots";
})(AveEvent || (AveEvent = {}));
var AveRequestEvent;
(function (AveRequestEvent) {
    AveRequestEvent["AVECameraDelta"] = "AVECameraDelta";
    AveRequestEvent["AVESetCameraFocusPoint"] = "AVESetCameraFocusPoint";
})(AveRequestEvent || (AveRequestEvent = {}));
var AveResponseEvent;
(function (AveResponseEvent) {
    // Session
    AveResponseEvent["AVEEndSessionUpdate"] = "AVEEndSessionUpdate";
    AveResponseEvent["AVEIdleSessionStartUpdate"] = "AVEIdleSessionStartUpdate";
    AveResponseEvent["AVEIdleSessionEndUpdate"] = "AVEIdleSessionEndUpdate";
    // Animation
    AveResponseEvent["AVEAnimationUpdate"] = "AVEAnimationUpdate";
    // Driving Scene
    AveResponseEvent["AVEDrivingSceneFinished"] = "AVEDrivingSceneFinished";
    // VR
    AveResponseEvent["AVEHideHSWOverlay_update"] = "AVEHideHSWOverlay_update";
    // Rendering
    AveResponseEvent["AVEImageUploaded_update"] = "AVEImageUploaded_update";
    AveResponseEvent["AVEImageSaved_update"] = "AVEImageSaved_update";
})(AveResponseEvent || (AveResponseEvent = {}));
export const AveRequestEvents = {
    ...AveEvent,
    ...AveRequestEvent
};
export const AveResponseEvents = {
    ...AveEvent,
    ...AveResponseEvent
};
//# sourceMappingURL=events.js.map